import { Collapse, IconButton, Typography, Box } from "@material-ui/core"
import { useState } from "react"
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown"
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp"
import TablaContrato from "../TablaContrato"
import TablaCompras from "../TablaCompras"
const Desplegable = () => {
    const [open, setOpen] = useState(false)
    return (
        <div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "flex-start", gap: "0.5rem"}}>
                <Typography variant="h6" gutterBottom component="div" onClick={() => setOpen(!open)}>
                 {
                    (open) ? "ver menos" : "ver más"
                 }
                </Typography>
                <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                    {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </IconButton>
            </div>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box margin={1}>
                   <TablaContrato />
                   <TablaCompras />
                </Box>
            </Collapse>
        </div>
    )
}
export default Desplegable